import { computed } from "vue";
import { useUidAttribute } from "composables/useUidAttribute";
import { useSharedState } from "composables/useSharedState";
import { useTable, SortDirection } from "./useTable";
import { tableHeaderCellVariants } from "./Table.styles";
import type { TableHeaderCellProps } from "./TableHeaderCellProps";

export interface UseTableHeaderCellOptions {
  props: Readonly<TableHeaderCellProps>;
}

export const useTableHeaderCell = (options: UseTableHeaderCellOptions) => {
  const { props } = options;
  useUidAttribute();
  const state = useSharedState(props);

  const { cellRef, isCellSortable, isColumnResizable, isLastColumn, sortColumn, startResize } = useTable();

  const isSorted = computed(() => isCellSortable.value && state.sortDirection?.value !== SortDirection.None);

  const variants = computed(() =>
    tableHeaderCellVariants({
      sortable: isCellSortable.value,
      sorted: isSorted.value,
      align: props.align,
    }),
  );

  const sortIconName = computed(() => {
    switch (state.sortDirection?.value) {
      case SortDirection.Ascending: {
        return "chevron-up";
      }
      case SortDirection.Descending: {
        return "chevron-down";
      }
      default: {
        return "";
      }
    }
  });

  return { cellRef, variants, isSorted, sortIconName, isColumnResizable, isLastColumn, sortColumn, startResize };
};
